import React, {useEffect} from 'react'
import styled from 'styled-components';
import Footer from '../Footer';
import Header from "../Header";
import Loans from '../Loans';


function Services() {
    useEffect(()=>{
        window.scrollTo(0,0)
      },[])
      
    return (
        <>
            <Header />
            <Banner>
                <div className="banner__container">
                    <div className="banner__content">
                        <h2>Our Services</h2>
                        <p>At <b>Winnthako</b> we believe in excellence. Hence not being jack of all trade and master of none. Here, we only focus on financial services</p>
                    </div>
                    <div className="banner__background"></div>
                </div>
            </Banner>
            <Loans/>
            <Footer/>
        </>
    )
}

const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;

        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url("/images/gallery/home_blog2.png");
        background-size: cover;
        background-position-x: center;

        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;

    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        max-width: 80%;
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
    }
    
`
export default Services
